import { useSelector } from "react-redux"
import { DecodeHtml } from "../../utils/decodeHtml"


const Uiac = () => {
    const state = useSelector(state => state.aboutUnitenContent)
    const aboutUniten = state?.data?.properties
    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })

    
    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            <p className='w-auto whitespace-pre-line'>{description}</p>

        </div>
    )
}

export default Uiac